<template>
  <div class="component-playback" id="playbackContent">
    <img
      class="playback-bg"
      src="https://p2.ssl.qhimg.com/t110b9a9301975134f31f751736.png"
      alt=""
    />
    <div class="playback-content">
      <div style="height: 706px; flex: 1; margin-right: 24px;">
        <play-show :data="currentData" type="pc" v-if="showVideo"></play-show>
        <div class="playback-none" v-else></div>
      </div>
      <div style="height: 706px; width: 539px">
        <play-tablist type="pc" @playVideo="playVideo"></play-tablist>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref, onMounted, watch } from 'vue'
import PlayShow from './play-show.vue'
import PlayTablist from './play-tablist.vue'

let showVideo = ref(false)

const currentData = ref({})
const playVideo = (data) => {
  currentData.value = data
  showVideo.value = false
  nextTick(() => {
    showVideo.value = true
  })
}

onMounted(() => {
  //整体缩放
    let resizeWindow = function (){
        let root = document.getElementById("app");
        if(window.innerWidth<1910){
            let fangdabili = window.innerWidth / 1910;
            root.style.transformOrigin = `0 0`       
            root.style.transform = `scale(${fangdabili})`       
            root.style.width = `${100/fangdabili}vw`      
            // root.style.padding = `${180/fangdabili}px 0 0`  
            root.style.height = `${100/fangdabili}vh`       
        }else{
            root.style.transformOrigin = ``       
            root.style.transform = ``       
            root.style.width = ``       
            root.style.height = `` 
        }
    }
    resizeWindow()
    window.addEventListener("resize",()=>{
        resizeWindow()
    })
})


</script>

<style lang="scss" scoped>
.component-playback {
//   min-height: 100vh;
  background: #f3f3f3;
  padding-top: 180px;
  .playback-bg {
    width: 100%;
    position: absolute;
    top: 0;
  }
  .playback-content {
    display: flex;
    // align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    .playback-none{
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 32px;
    }
  }
}
</style>
